import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { client } from '../util/client';

export type RegistrationStatus = {
  acceptingPatients: boolean;
  closedAt: string | null;
  reopenAt: string | null;
};

// The borne sits on the MMG landing for hours, so a closure (or the automatic
// reopening) has to reach it without anyone reloading the tablet (ALDO-2800).
const POLL_INTERVAL_MS = 60_000;

export const useRegistrationStatus = (practiceId: number | undefined) =>
  useQuery<RegistrationStatus, AxiosError>(
    ['practice', practiceId, 'registration-status'],
    () =>
      client(`/practice/${practiceId}/registration-status`).then(
        (response) => response.data,
      ),
    {
      enabled: !!practiceId,
      refetchInterval: POLL_INTERVAL_MS,
      // A failed check must never block check-in: the screen falls back to
      // open, as it was before this feature existed.
      retry: false,
    },
  );
